import { Users, Tag, Coins } from 'lucide-react'
import type { Recommendation } from '../../lib/types'
import { formatPrice } from '../../lib/format'
import { categoryLabel, isKnownCategory } from './humanize'
import { Badge } from '../ui'

interface MetaChipsProps {
  rec: Pick<Recommendation, 'store_categories' | 'price' | 'coverage_met'>
  rosterSize?: number
}

/** Neutral metadata chips (design-system §6.8) — players, price, mode tags. */
export function MetaChips({ rec, rosterSize }: MetaChipsProps) {
  const priceLabel = formatPrice(rec.price)
  const categories = rec.store_categories.filter(isKnownCategory).slice(0, 3)

  return (
    <div className="flex flex-wrap items-center gap-2">
      {rec.coverage_met != null && rosterSize != null && rosterSize > 1 && (
        <Badge icon={<Users className="h-3.5 w-3.5" strokeWidth={2} />}>
          <span className="tabular-nums">
            {rec.coverage_met}/{rosterSize}
          </span>{' '}
          would love it
        </Badge>
      )}
      {priceLabel && (
        <Badge icon={<Coins className="h-3.5 w-3.5" strokeWidth={2} />}>
          <span className="tabular-nums">{priceLabel}</span>
        </Badge>
      )}
      {categories.map((c) => (
        <Badge key={c} icon={<Tag className="h-3.5 w-3.5" strokeWidth={2} />}>
          {categoryLabel(c)}
        </Badge>
      ))}
    </div>
  )
}
